import { useMutation } from '@tanstack/react-query';
import { deleteMedia } from '../../api/apiMedias';
import toast from 'react-hot-toast';

export const useDeleteMedia = () => {
    const { mutate: deleteMediaMutation, isPending: isDeleting } = useMutation({
        mutationFn: deleteMedia,
        onSuccess: (response) => {
            toast.success(response.message || 'File deleted successfully');
            return response;
        },
        onError: (error) => {
            const errorMessage = error.response?.data?.message || 'Delete failed';
            toast.error(errorMessage);
            throw error;
        },
    });

    const deleteSingleMedia = (id) => {
        return new Promise((resolve, reject) => {
            deleteMediaMutation(id, {
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            });
        });
    };

    return {
        deleteSingleMedia,
        isDeleting,
    };
};
